import { apply, put, select } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import {
  onLoadChecklistsSucceeded,
  onLoadChecklistRunsSucceeded,
  onLoadChecklistSucceeded,
  onSubmitChecklistSucceeded,
  onStartChecklistSucceeded,
  onSearchChecklistSucceeded,
  getPinnedContentSuccessAction,
  loadDefaultBulletinBoardSucceeded,
  pinOrUnpinContentSuccessAction,
  onLoadChecklistToDosFailed,
  onLoadChecklistToDosSucceeded,
  onLoadChecklistDueDatesFailed,
  onLoadChecklistDueDatesSucceeded,
  onLoadChecklistFailed,
  selectChecklistToDo,
} from '../reducers/checklist.reducers';

import {
  errorNotification,
  successNotification,
} from '../reducers/notification.reducers';

export function* loadChecklists(checklistApi) {
  const response = yield apply(
    checklistApi,
    checklistApi.loadChecklistsAndGroups
  );
  if (response.errorCode) {
    yield put(errorNotification('Fehler beim Laden der Checklisten'));
  } else {
    yield put(onLoadChecklistsSucceeded({ checklists: response }));
  }
}

export function* loadChecklistRuns(checklistApi, { payload }) {
  const response = yield apply(checklistApi, checklistApi.loadChecklistRuns);
  if (!response || response.errorCode) {
    yield put(errorNotification('Fehler beim Laden der Checklist Durchläufe'));
  } else {
    yield put(onLoadChecklistRunsSucceeded({ checklistRuns: response }));
  }
}

export function* sendChecklistRunAction(checklistApi, { payload }) {
  try {
    const checklistRunDto = {
      startDate: yield select(
        (state) => state.checklists.checklistRunStartedAt
      ),
      cardId: payload.card.id,
      action: payload.type,
    };

    yield apply(checklistApi, checklistApi.sendRunAction, [checklistRunDto]);
  } catch (e) {
    console.log(e);
  }
}

export function* finishChecklistRun(checklistApi) {
  try {
    const checklistFinishedDto = {
      startDate: yield select(
        (state) => state.checklist.selectedChecklistRun.startDate
      ),
      checklistId: yield select(
        (state) => state.checklist.selectedChecklistRun.checklistId
      ),
    };

    yield apply(checklistApi, checklistApi.finishRun, [checklistFinishedDto]);

    yield loadChecklists(checklistApi);
  } catch (e) {
    console.log(e);
  }
}

export function* loadChecklistToDoChecklistItems(checklistApi, { payload }) {
  try {
    // yield loadChecklists(checklistApi);

    const checklistRuns = yield select(
      (state) => state.checklists.checklistRuns
    );
    const openRun = checklistRuns.find((t) => t.checklistId == payload.id);
    let response = null;
    if (openRun) {
      response = yield apply(
        checklistApi,
        checklistApi.loadActiveChecklistToDoChecklistItems,
        [openRun.id]
      );
    } else {
      response = yield apply(
        checklistApi,
        checklistApi.loadChecklistToDoChecklistItems,
        [payload.id]
      );
    }

    // const response = yield apply(
    //   checklistApi,
    //   checklistApi.loadChecklistChecklistItems, [payload.id]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Tasks'));
    } else {
      /*yield put(
        onLoadChecklistSucceeded({
          checklistItems: response,
          checklist: payload,
        })
      );*/
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Tasks'));
  }
}

export function* resetChecklistProgress(checklistApi) {
  try {
    const checklistId = yield select(
      (state) => state.checklists.selectedChecklistId
    );

    yield apply(checklistApi, checklistApi.resetProgress, [checklistId]);
  } catch (e) {
    console.log(e);
  }
}

export function* searchChecklist(checklistApi, { payload }) {
  const searchDto = {
    searchTerm: payload,
  };

  try {
    const response = yield apply(checklistApi, checklistApi.search, [
      searchDto,
    ]);

    if (response.errorCode) {
      yield put(errorNotification('Fehler bei der Suche'));
    } else {
      yield put(onSearchChecklistSucceeded(response));
    }
  } catch (e) {
    console.log(e);
  }
}

export function* startChecklist(checklistApi, { payload }) {
  try {
    const response = yield apply(checklistApi, checklistApi.startChecklistRun, [
      payload,
    ]);
    yield put(onStartChecklistSucceeded(response));
  } catch (e) {}
}

export function* exportPdf(checklistApi, { payload }) {
  yield put(successNotification('Der Download startet in Kürze'));
  const state = yield select();
  const token = state.authentication.accessToken;
  const urlParams = {
    url: encodeURIComponent(payload),
    token,
  };

  try {
    const response = yield apply(checklistApi, checklistApi.generatePdf, [
      urlParams,
    ]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Exportieren'));
    }

    FileSaver.saveAs(response, 'export.pdf');
  } catch (e) {
    yield put(errorNotification('Fehler beim Exportieren'));
  }
}

export function* loadDefaultBulletinBoard(checklistApi) {
  try {
    const response = yield apply(
      checklistApi,
      checklistApi.getDefaultBulletinBoard
    );

    if (response.error || !response) {
      // handle error
    } else {
      yield put(loadDefaultBulletinBoardSucceeded(response));
    }
  } catch (e) {
    yield put(errorNotification('Fehler'));
  }
}

export function* loadChecklistToDos(checklistApi, { payload }) {
  try {
    const response = yield apply(checklistApi, checklistApi.getChecklistToDos);

    if (response.error) {
      yield put(errorNotification('Fehler beim Laden der ChecklistToDos'));
      yield put(onLoadChecklistToDosFailed());
    } else {
      yield put(onLoadChecklistToDosSucceeded(response));
      if (payload) {
        yield put(selectChecklistToDo(payload));
      }
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Laden der ChecklistToDos'));
    yield put(onLoadChecklistToDosFailed());
  }
}

export function* loadChecklistDueDates(checklistApi, { payload }) {
  try {
    const response = yield apply(
      checklistApi,
      checklistApi.getChecklistDueDates
    );

    if (response.error) {
      yield put(errorNotification('Fehler beim Laden der ChecklistDueDates'));
      yield put(onLoadChecklistDueDatesFailed());
    } else {
      yield put(
        onLoadChecklistDueDatesSucceeded({ checklistDueDates: response })
      );
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Laden der ChecklistDueDates'));
    yield put(onLoadChecklistDueDatesFailed());
  }
}

export function* getPinnedContent(checklistApi, { payload }) {
  try {
    const { boardId, sortFilterDto } = payload;

    const response = yield apply(checklistApi, checklistApi.getPinnedContent, [
      boardId,
      sortFilterDto,
    ]);

    if (!response.error) {
      yield put(getPinnedContentSuccessAction(response));
    }
  } catch (e) {
    yield put(errorNotification('Fehler'));
  }
}

export function* pinOrUnpinContent(checklistApi, { payload }) {
  const { bulletinBoardId, pinningDto } = payload;

  try {
    const response = yield apply(checklistApi, checklistApi.pinOrUnpinItem, [
      bulletinBoardId,
      pinningDto,
    ]);

    if (!response.error) {
      // yield put(getPinnedContentAction({boardId: bulletinBoardId, sortFilterDto:{}}))
      // yield put(loadCardsForBoardAction({boardId: bulletinBoardId, sortFilterDto:{}}))
      yield put(pinOrUnpinContentSuccessAction(pinningDto));
    }
  } catch (e) {
    yield put(errorNotification('Fehler'));
  }
}

export function* removeChecklistRun(checklistApi, { payload }) {
  try {
    yield apply(checklistApi, checklistApi.removeChecklistRun, [payload]);
  } catch (e) {
    console.log(e);
  }
}

export function* submitChecklistRun(checklistApi, { payload }) {
  try {
    const checklists = yield select((state) => state.checklists);

    const checklistId = checklists.selectedChecklist.id;

    const answers = Object.keys(checklists.answersGiven).map(
      (checklistItemId) => {
        const tickedAnswerIds =
          checklists.answersGiven[checklistItemId].tickedAnswerIds;
        return {
          checklistItemId,
          tickedAnswerIds,
        };
      }
    );

    const checklistDto = {
      checklistId,
      startDate: checklists.runStartedAt,
      endDate: new Date().toISOString(),
      answers,
    };

    const response = yield apply(checklistApi, checklistApi.submitChecklist, [
      checklistDto,
    ]);

    if (response.error) {
      yield put(errorNotification('Fehler beim übermitteln der Checkliste'));
    } else {
      yield put(onSubmitChecklistSucceeded());
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim übermitteln der Checkliste'));
  }
}

export function* loadChecklist(checklistApi, { payload }) {
  try {
    const response = yield apply(checklistApi, checklistApi.loadChecklist, [
      payload,
    ]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Laden der Checkliste'));
      yield put(onLoadChecklistFailed());
    } else {
      yield put(onLoadChecklistSucceeded(response));
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Laden der Checkliste'));
    yield put(onLoadChecklistFailed());
  }
}



// WEBPACK FOOTER //
// ./src/app/sagas/checklist.sagas.js